import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["search"];
import { useLocation } from 'quartz-routing/react-router';
import { VIDEO_TIMESTAMP_PARAM } from '../video';
import UsageTracker from '../../utils/UsageTracker';
import { useCallback, useState } from 'react';
import { readUnhandledEnumCase } from 'rpc-client-utils';
import getLang from 'I18n/utils/getLang';
const STRIPPED_PARAMS_ON_NAVIGATE = [VIDEO_TIMESTAMP_PARAM];
export const useSanitizedLocation = () => {
  const _useLocation = useLocation(),
    {
      search
    } = _useLocation,
    props = _objectWithoutPropertiesLoose(_useLocation, _excluded);
  const queryParams = new URLSearchParams(search);
  STRIPPED_PARAMS_ON_NAVIGATE.forEach(p => {
    if (queryParams.has(p)) queryParams.delete(p);
  });
  return Object.assign({}, props, {
    search: queryParams.toString()
  });
};
export const useNavPageHandlers = ({
  appearsIn = 'heading-nav'
} = {}) => {
  const [searchValue, setSearchValue] = useState('');
  const onTabClick = useCallback(tabId => {
    UsageTracker.trackStandalone('Academy Nav Interaction', {
      action: `${tabId}-clicked`
    });
  }, []);
  const onCatalogOptionClick = useCallback((option, filterType) => {
    UsageTracker.trackStandalone('Catalog Dropdown Interaction', {
      action: 'catalog-option-selected',
      value: option,
      key: filterType
    });
    UsageTracker.trackStandalone('Filter Interaction', {
      action: 'filter-selected',
      value: option,
      key: filterType,
      isDropdown: true
    });
  }, []);
  const onAutocompletePopularContentSelected = useCallback((popularContent, index) => {
    const {
      name: resourceName,
      contentType: resourceType,
      language,
      certificate
    } = popularContent;
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'main-search-autocomplete-selected',
      name: resourceName,
      search: searchValue,
      contentType: readUnhandledEnumCase(resourceType),
      language: readUnhandledEnumCase(language),
      isCertification: certificate,
      position: index + 1,
      appearsIn: 'content',
      source: appearsIn
    });
  }, [appearsIn, searchValue]);
  const onAutocompleteSuggestionSelected = useCallback((suggestion, index) => {
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'main-search-autocomplete-selected',
      name: suggestion,
      search: searchValue,
      language: getLang(),
      position: index + 1,
      appearsIn: 'suggestions',
      source: appearsIn
    });
  }, [appearsIn, searchValue]);
  const onSearchValueChange = useCallback(newSearchValue => {
    setSearchValue(newSearchValue);
    if (newSearchValue.length > 0) {
      UsageTracker.trackStandalone('Learning Center Interaction', {
        action: 'main-search-input',
        search: newSearchValue,
        source: appearsIn
      });
    }
  }, [appearsIn]);
  const onSearchExecute = useCallback(searchedValue => {
    UsageTracker.trackStandalone('Learning Center Interaction', {
      action: 'main-search-term-executed',
      search: searchedValue,
      source: appearsIn
    });
  }, [appearsIn]);
  return {
    onAutocompletePopularContentSelected,
    onAutocompleteSuggestionSelected,
    onCatalogOptionClick,
    onSearchEnter: onSearchExecute,
    onSearchValueChange,
    onTabClick,
    onSearchClick: onSearchExecute
  };
};